import { ChangeDetectorRef, Component } from '@angular/core'
import { AlertService } from '../../services/alert.service'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { map, distinctUntilChanged } from 'rxjs/operators'
import { UiService } from 'src/app/services/ui.service'

@Component({
  selector: 'app-arpio-alert',
  templateUrl: './arpio-alert.component.html',
  styleUrls: ['./arpio-alert.component.scss'],
  standalone: false,
})
export class ArpioAlertComponent {
  previewText: string | SafeHtml | null = null
  public awsOutageObj$ = this.alertService.data$.pipe(
    map((data) => {
      const item = data.find((item) => item.category === 'outage')
      if (item) {
        return { ...item, safeHtml: this.sanitizer.bypassSecurityTrustHtml(item.message) }
      }
      return undefined
    }),
    distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr))
  )

  constructor(
    public alertService: AlertService,
    private sanitizer: DomSanitizer,
    private uiService: UiService,
    private cdr: ChangeDetectorRef
  ) {
    // This expands the width of the component
    this.uiService.isCustomComponent$.next(true)
  }

  onPreviewTextChange(newText: string) {
    this.previewText = newText
    this.cdr.detectChanges()
  }

  onshowBannerChange(showBanner: boolean) {
    this.alertService.onshowBannerChange(showBanner)
  }

  ngOnDestroy(): void {
    this.uiService.isCustomComponent$.next(false)
  }
}
